export default __webpack_public_path__ + "static/media/add.07aade25.svg";